import { useRouter } from 'next/router'
import styles from './StickyActionBar.module.scss'

export default function StickyActionBar() {
  const router = useRouter()

  const handleShare = () => {
    navigator.share({
      title: document.title,
      text: window.location.href,
      url: `${window.location.href.split('?')[0]}?ref=mobileShare`,
    })
  }

  return (
    <section className={styles.section}>
      <div
        id="stickyActionBarBack"
        className={styles.icon}
        onClick={() => router.back()}
      >
        <img
          src="/img/arrow-right.svg"
          alt="nuoli"
          className={styles.arrowRotation}
        />
      </div>
      <a
        id="stickyActionBarSendInquiry"
        href="#tarjous"
        className={styles.contentText}
      >
        <button className={styles.rectangleButton}>Lähetä tarjouspyyntö</button>
      </a>
      <div
        id="stickyActionBarShare"
        className={styles.icon}
        onClick={handleShare}
      >
        <img src="/img/share-variant.svg" alt="jaa" />
      </div>
    </section>
  )
}
